// import XLSX from 'sheetjs-style';
import ExcelJS from 'exceljs';
import FileSaver  from 'file-saver';
import {breakTitle} from "../Custom/Custom";



 
export const generateExcel = async (excelObjectData) => {

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet(excelObjectData.sheetName);

  //First Row Design and Merge cells A1:L1
  worksheet.mergeCells(excelObjectData.firstRowMergeCells);
  const firstHeaderRow = worksheet.getRow(1);
  firstHeaderRow.getCell(1).value = excelObjectData.firstRowText
  const firstRowFontSize = excelObjectData.firstRowFontSize || 14;
  firstHeaderRow.getCell(1).font = { bold: true,name: 'SansSerif',size:firstRowFontSize };
  firstHeaderRow.getCell(1).alignment = { horizontal: 'center',vertical: 'middle',wrapText: true };
  firstHeaderRow.height = 30;
  firstHeaderRow.getCell(excelObjectData.firstRowCellNumber).value = excelObjectData.firstRowText; 
  firstHeaderRow.getCell(excelObjectData.firstRowCellNumber).font = { bold: true,name: 'SansSerif',size:12 }; //cell No- 13
  firstHeaderRow.getCell(excelObjectData.firstRowCellNumber).alignment = { horizontal: 'center',vertical: 'middle',wrapText: true };
  
  //Second Row Design and  Merge cells A2:M2 (only if secondRowMergeCells exists)
  if (excelObjectData.secondRowMergeCells && excelObjectData.secondRowText) {
    worksheet.mergeCells(excelObjectData.secondRowMergeCells); 
    const secondHeaderRow = worksheet.getRow(2);
    secondHeaderRow.getCell(1).value = excelObjectData.secondRowText;
    secondHeaderRow.getCell(1).font = { name: 'SansSerif',size:12};
    secondHeaderRow.getCell(1).alignment = { horizontal: 'center',vertical: 'middle',wrapText: true};
    secondHeaderRow.height = 20;
    secondHeaderRow.getCell(1).border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    };
  }

    //excel English Column (only if headerEnglishColumns exists)
    if (excelObjectData.headerEnglishColumns && excelObjectData.headerEnglishColumns.length > 0) {
      const headerRow3 = worksheet.addRow(excelObjectData.headerEnglishColumns);
      headerRow3.height=55;
      headerRow3.eachCell((cell,colNumber ) => {
        cell.font = { bold: true, name: 'SansSerif',size:10};
        cell.alignment = { horizontal: 'center',vertical: 'middle',wrapText: true };
        cell.value = breakTitle(cell.value);
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' },
          
        };
        const column = worksheet.getColumn(colNumber);
        column.width = 16;
          
       });
    }

      //excel Hindi Column (add to row 3 if English columns don't exist, otherwise row 4)
    const hindiRowNumber = (excelObjectData.headerEnglishColumns && excelObjectData.headerEnglishColumns.length > 0) ? 4 : 3;
    const headerRowHindi = worksheet.addRow(excelObjectData.headerHindiColumns);
    headerRowHindi.height=55;
    headerRowHindi.eachCell((cell,colNumber) => {
      cell.font = { bold: true, name: 'SansSerif',size:10 };
      cell.alignment = { horizontal: 'center',vertical: 'middle',wrapText: true };
      cell.value = breakTitle(cell.value);
      cell.width=50;
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
      const column = worksheet.getColumn(colNumber);
      column.width = 16;
     });
  

  
  
    excelObjectData.excelRowData.forEach((row) => {  //Excel Data Loop
      const dataRow = worksheet.addRow(row);
      dataRow.height=27;
      row.forEach((value, index) => {
        const cell = dataRow.getCell(index + 1);
        cell.font = {  name: 'SansSerif',size:10 };
        cell.alignment = { horizontal: 'center',vertical: 'middle',wrapText: true };
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' },
        };
        // Customize styling for the cells if needed
      });
     
    });
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
    const fileName=`${excelObjectData.fileName}.${excelObjectData.fileType}`;
    FileSaver.saveAs(blob, fileName);
};


  
export const generateExcelASI = async (excelObjectData) => {

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet(excelObjectData.sheetName);

  //First Row Design and Merge cells A1:K1
  worksheet.mergeCells(excelObjectData.firstRowMergeCells);
  const firstHeaderRow = worksheet.getRow(1);
  firstHeaderRow.getCell(1).value = excelObjectData.firstRowExportDate
  firstHeaderRow.getCell(1).font = {name: 'SansSerif',size:20,color: { argb: 'ff7966' }};
  firstHeaderRow.getCell(1).alignment = { horizontal: 'center',vertical: 'middle',wrapText: true };
  firstHeaderRow.height = 30;
 
  
  //Second Row Design and  Merge cells A2:K1
  worksheet.mergeCells(excelObjectData.secondRowMergeCells); 
  const secondHeaderRow = worksheet.getRow(2);
  secondHeaderRow.getCell(1).value = excelObjectData.secondRowText;
  secondHeaderRow.getCell(1).font = { name: 'SansSerif',size:12};
  secondHeaderRow.getCell(1).alignment = { horizontal: 'center',vertical: 'middle',wrapText: true};
  secondHeaderRow.height = 20;
  secondHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };


  
//Third Row Design and  Merge cells A3:L3
  worksheet.mergeCells(excelObjectData.thirdRowMergeCells); 
  const thirdHeaderRow = worksheet.getRow(3);
  thirdHeaderRow.getCell(1).value = excelObjectData.thirdRowText;
  thirdHeaderRow.getCell(1).font = { name: 'SansSerif',size:12};
  thirdHeaderRow.getCell(1).alignment = { horizontal: 'center',vertical: 'middle',wrapText: true};
  thirdHeaderRow.height = 20;
  thirdHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };


  //Fourth Row Design and  Merge cells A3:L3
  worksheet.mergeCells(excelObjectData.fourthRowMergeCells); 
  const fourthHeaderRow = worksheet.getRow(4);
  fourthHeaderRow.getCell(1).value = excelObjectData.fourthRowText;
  fourthHeaderRow.getCell(1).font = { name: 'SansSerif',size:12};
  fourthHeaderRow.getCell(1).alignment = { horizontal: 'center',vertical: 'middle',wrapText: true};
  fourthHeaderRow.height = 20;
  fourthHeaderRow.getCell(1).border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };
 
    //excel English Column
    const headerRow3 = worksheet.addRow(excelObjectData.headerEnglishColumns);
    headerRow3.height=55;
    headerRow3.eachCell((cell,colNumber ) => {
      cell.font = { bold: true, name: 'SansSerif',size:10};
      cell.alignment = { horizontal: 'center',vertical: 'middle',wrapText: true };
      cell.value = breakTitle(cell.value);
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
        
      };
      const column = worksheet.getColumn(colNumber);
      column.width = 25;
        
     });
    
    excelObjectData.excelRowData.forEach((row) => {  //Excel Data Loop
      const dataRow = worksheet.addRow(row);
      dataRow.height=null;
      let isTotalRow = false;
      row.forEach((value, index) => {
        const cell = dataRow.getCell(index + 1);
        cell.font = {  name: 'SansSerif',size:10 };
        cell.alignment = { horizontal: 'center',vertical: 'middle',wrapText: true };
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' },
        };
        if (value === 'TOTAL') {
          isTotalRow = true;
        }
        // Customize styling for the cells if needed
      });

      if (isTotalRow) {
        dataRow.eachCell({ includeEmpty: true }, (cell) => {
          cell.font = { name: 'SansSerif', size: 12, bold: true };
        });
      }
     
    });
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
    const fileName=`${excelObjectData.fileName}.${excelObjectData.fileType}`;
    FileSaver.saveAs(blob, fileName);
};